import React from 'react';
import { makeStyles } from 'tss-react/mui';
import palette from '@ui/palette';
import Typography from '@ui/Typography';
import { findTeamMember } from 'components/Team/teamUtils';
import { useUserTeam } from '../../../context/user/UserContext';

interface CommentMentionTagProps {
  userId: string;
}

const DEACTIVATED_LABEL = 'Deactivated User';

const CommentMentionTag = ({ userId }: CommentMentionTagProps) => {
  const userTeam = useUserTeam();
  const { classes, cx } = useStyles();

  const displayName = React.useMemo(() => {
    const teamMember = findTeamMember(userTeam, userId);
    if (teamMember) {
      return teamMember.name;
    }
    return DEACTIVATED_LABEL;
  }, [userId, userTeam]);

  const isDeactivated = displayName === DEACTIVATED_LABEL;
  return (
    <Typography
      variant="pSm"
      bold={!isDeactivated}
      component={'span'}
      className={cx({
        [classes.deactivated]: isDeactivated,
      })}
    >
      @{displayName}
    </Typography>
  );
};

const useStyles = makeStyles()(theme => ({
  deactivated: {
    color: palette.gray_300,
  },
}));

export default CommentMentionTag;
